"use strict";require('@ebay/skin/select');
require('@ebay/skin/icon');